import { render, staticRenderFns } from "./CandidatosSeleccionTab.vue?vue&type=template&id=68a84a1e&"
import script from "./CandidatosSeleccionTab.vue?vue&type=script&lang=js&"
export * from "./CandidatosSeleccionTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports